import { WebinarDetailsPage } from '@online-webinar/public';
import { RouterType } from '@online-webinar/router';

export const updateRoute = (router: RouterType) => {
    router.routesById['/$webinarId/'].update({
        staticData: { title: { webinarTitle: true } },
        component: WebinarDetailsPage
    });
};
